import { render, staticRenderFns } from "./EditClientAddress.vue?vue&type=template&id=98aa7988"
import script from "./EditClientAddress.vue?vue&type=script&lang=js"
export * from "./EditClientAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports